import './p2.css';
import phone from './Icons/nophone.svg';
import takeout from './Icons/takeout.svg';
import circle from './Icons/circle.svg';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from './navbar.js';
import SiteCounter from './SiteCounter.js';

const P2 = ({isPortrait}) => {
    const [secretCounter, setSecretCounter] = useState(1);

    var didOnce = false;
    const SecretClick = () => {
        if (secretCounter === 25 && !didOnce) {
            didOnce = true;
            window.open('https://i.imgflip.com/2xfocv.jpg', '_blank')
        } else if (!didOnce){
            setSecretCounter(secretCounter + 1);
        }

    }

    const v1 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    // Animation variants for the symbol-text pair
    const v2 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 0.5 } }, // Delayed to start after text
    };

    const v3 = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 1 } }, // Delayed to start after text
    };

    return (
        <div className='layout'>
            <div className='title' />
            <SiteCounter />
            <div className={`content-center ${isPortrait ? '' : 'content-center-landscape'}`}>

                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={v1}
                    transition={{ duration: 0.5 }}

                 className='symbol-text-pair'>
                        <img className={`symbol ${isPortrait ? '' : 'symbol-landscape'}`} src={phone} alt="Phone" />
                        <h4 className='text'>Focus on your dreams.</h4>
                   
                </motion.div>
                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={v2}
                    transition={{ duration: 0.5 }}

                 className='symbol-text-pair'>
                        <motion.div className="circle-container" whileTap={{ scale: 0.6 }} transition={{ duration: 0.3 }} onClick={() => SecretClick()}>
                            <img className={`symbol ${isPortrait ? '' : 'symbol-landscape'}`} src={circle} alt="One"  />
                            <div className="number">{secretCounter}</div>
                        </motion.div>

                        <h4 className='text'>One bowl per customer.</h4>
                  
                </motion.div>
                <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={v3}
                    transition={{ duration: 0.5 }}

                className='symbol-text-pair'>
                        <img className={`symbol ${isPortrait ? '' : 'symbol-landscape'}`} src={takeout} alt="Takeout" />
                        <h4 className='text'>No takeout.</h4>
                   
                </motion.div>
            </div>

            <Navbar isPortrait={isPortrait} />
        </div>

    );
};

export default P2;
